import React from 'react';
import classnames from 'classnames';
import I18N from '@leverege/i18n';
import { Content, Dialog, Pane, Button, Flex, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import S from './LocatorAtSisterLocation.css';
import Detail from '../../pairing/intermediate/Detail';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.views.salesFlow.components.LocatorAtSisterLocation');
function SalesFlowLocatorSearch(props) {
  const {
    onClose,
    show,
    locatorLocation,
    onCancel
  } = props;
  const areaClassName = classnames(S.contentArea, S.pad);
  const footerClassName = classnames(S.pad);
  const closeDialog = () => {
    // wipe out locator value if user cancels
    onCancel(false);
    onClose();
  };
  const onConfirm = () => {
    // set value of locator if user confirms using sister location's locator
    onCancel(true);
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog, {
    animation: "fade",
    onClose: onClose,
    show: show,
    position: "center",
    children: /*#__PURE__*/_jsx(Pane, {
      className: S.container,
      children: /*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsx(Content.Header, {
          children: /*#__PURE__*/_jsx(TitleBar, {
            variant: "dialogTitle",
            title: t('title'),
            icon: tIcon('titleIcon')
          })
        }), /*#__PURE__*/_jsx(Content.Area, {
          className: areaClassName,
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "colL",
            children: [/*#__PURE__*/_jsx("img", {
              className: S.locatorError,
              src: tIcon('locatorElsewhereIcon'),
              alt: t('locatorWarning'),
              height: 92,
              width: 136
            }), /*#__PURE__*/_jsx(Text, {
              variant: "formTitle",
              children: t('subtitle')
            }), /*#__PURE__*/_jsx(Text, {
              children: t('message')
            }), /*#__PURE__*/_jsx(Pane, {
              variant: "dashboardCard",
              children: /*#__PURE__*/_jsx(Pane, {
                layout: "flex:col",
                variant: "dataCard",
                children: /*#__PURE__*/_jsx(Detail, {
                  className: S.detailPair,
                  label: t('label'),
                  value: locatorLocation?.data?.name || t('unknown')
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsxs(Content.Footer, {
          className: footerClassName,
          layout: "flex:rowMEnd",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: closeDialog,
            variant: "secondary",
            children: t('cancel')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            onClick: onConfirm,
            children: t('confirm')
          })]
        })]
      })
    })
  });
}
export default SalesFlowLocatorSearch;